export default __webpack_public_path__ + "static/media/Freebooter's Vambraces of the Savage Sun.86f98a70.jpg";